/** Popup root class. Arrays inside it need a ghost parent outside CSS transforms. */
export const ICON_OVERLAY_CLASS = 'c-FlowV2-icon-property-overlay';

/**
 * smooth-dnd listens for mousedown/touchstart on document (bubble).
 * The icon overlay must not stop those, or array reorder never starts.
 * pointerdown still stops so the canvas does not treat the press as a paper hit.
 */
export function shouldStopOverlayPress(eventType) {
    return eventType !== 'mousedown' && eventType !== 'touchstart';
}

/**
 * smooth-dnd position:fixed ghosts are positioned against a transformed ancestor.
 * The essentials popup scales its content, and the shell scales with graph zoom.
 * Return document.body when `el` is inside that popup; otherwise null so the
 * library keeps its default parent.
 */
export function ghostParentForIconOverlay(el) {
    if (el && typeof el.closest === 'function' && el.closest('.' + ICON_OVERLAY_CLASS))
        return document.body;
    return null;
}
